// // src/components/Combinations.jsx

// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { CombinationContext } from '../contexts/CombinationContext';

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } = useContext(CombinationContext);

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   return (
//     <div className="category app-wrapper">
//       <h2>Kombinationen</h2>
//       <ul>
//         {kombinationen.map((item) => (
//           <li key={item.id}>
//             {/* Ссылка для перехода к деталям комбинации */}
//             <Link to={`/kombi/${item.id}`} style={{ textDecoration: 'none', color: '#007BFF' }}>
//               {item.Name}
//             </Link>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Combinations;



// NORMAL CARDS


// src/components/Combinations.jsx

// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { CombinationContext } from '../contexts/CombinationContext';
// import '../styles/Category.css'; // Убедитесь, что стили доступны

// const Combinations = () => {
//     const { kombinationen, loadingKombinationen, errorKombinationen } = useContext(CombinationContext);

//     // Функция для формирования URL иконки
//     const getIconUrl = (icon) => {
//         if (!icon || !icon.filename_disk) return null;
//         const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//         return `${baseUrl}${icon.filename_disk}`;
//     };

//     if (loadingKombinationen) {
//         return <p>Lade Kombinationen...</p>;
//     }

//     if (errorKombinationen) {
//         return <p>Fehler: {errorKombinationen}</p>;
//     }

//     return (
//         <div className="category app-wrapper">
//             <h1 className="title-category">
//                 Hier findest du alle <br /> <span>Kombis im Detail</span>
//             </h1>

//             {/* Отображение комбинаций как карточек */}
//             <div className="cards2">
//                 {kombinationen.map((kombination) => {
//                     const iconUrl = getIconUrl(kombination.Icon);
//                     return (
//                         <Link
//                             to={`/kombi/${kombination.id}`}
//                             key={kombination.id}
//                             className="card-wrapper2"
//                             style={{ textDecoration: 'none', color: 'inherit' }}
//                         >
//                             <div className="card2">
//                                 {/* Отображение иконки */}
//                                 {iconUrl ? (
//                                     <img
//                                         src={iconUrl}
//                                         alt={kombination.Name}
//                                         className="category-icon"
//                                         loading="lazy"
//                                         onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }}
//                                     />
//                                 ) : (
//                                     <div className="category-icon-placeholder"></div>
//                                 )}
//                                 <p>{kombination.Name}</p>
//                             </div>
//                         </Link>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };

// export default Combinations;


// GROUP CARDS

// src/components/Combinations.jsx

// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { CombinationContext } from '../contexts/CombinationContext';
// import '../styles/Category.css'; // Убедитесь, что стили доступны

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } = useContext(CombinationContext);

//   // Функция для формирования URL иконки
//   const getIconUrl = (icon) => {
//     if (!icon || !icon.filename_disk) return null;
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//     return `${baseUrl}${icon.filename_disk}`;
//   };

//   // Функция для определения группы по названию
//   const getGroup = (name) => {
//     if (!name) return null;
//     const upperName = name.toUpperCase();

//     if (upperName.startsWith('BE')) {
//       return 'Anhängerg';
//     } else if (upperName.startsWith('A')) {
//       return 'zweirad';
//     } else if (upperName.startsWith('B')) {
//       return 'Auto';
//     } else if (upperName.startsWith('C')) {
//       return 'LKW';
//     }
//     return null; // Если не соответствует ни одной группе
//   };

//   // Функция для группировки комбинаций
//   const groupCombinations = (kombinationen) => {
//     const groups = {
//       zweirad: [],
//       Auto: [],
//       LKW: [],
//       Anhängerg: []
//     };

//     kombinationen.forEach((kombination) => {
//       const group = getGroup(kombination.Name);
//       if (group && groups[group]) {
//         groups[group].push(kombination);
//       }
//     });

//     return groups;
//   };

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   // Группировка комбинаций
//   const groupedCombinations = groupCombinations(kombinationen);

//   // Порядок отображения групп
//   const groupOrder = ['zweirad', 'Auto', 'LKW', 'Anhängerg'];

//   return (
//     <div className="category app-wrapper">
//       <h2>Kombinationen</h2>

//       {groupOrder.map((groupName) => {
//         const combinations = groupedCombinations[groupName];
//         if (!combinations || combinations.length === 0) return null;

//         // Определение заголовка группы
//         let groupTitle = '';
//         switch (groupName) {
//           case 'zweirad':
//             groupTitle = 'Zweirad';
//             break;
//           case 'Auto':
//             groupTitle = 'Auto';
//             break;
//           case 'LKW':
//             groupTitle = 'LKW';
//             break;
//           case 'Anhängerg':
//             groupTitle = 'Anhänger';
//             break;
//           default:
//             groupTitle = '';
//         }

//         return (
//           <div key={groupName} className="group-section">
//             <h3 className="section-title">{groupTitle}</h3>
//             <div className="cards2">
//               {combinations.map((kombination) => {
//                 const iconUrl = getIconUrl(kombination.Icon);
//                 return (
//                   <Link 
//                     to={`/kombi/${kombination.id}`} 
//                     key={kombination.id} 
//                     className="card-wrapper2"
//                     style={{ textDecoration: 'none', color: 'inherit' }}
//                   >
//                     <div className="card2">
//                       {/* Отображение иконки */}
//                       {iconUrl ? (
//                         <img
//                           src={iconUrl}
//                           alt={kombination.Name}
//                           className="category-icon"
//                           loading="lazy"
//                           onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }}
//                         />
//                       ) : (
//                         <div className="category-icon-placeholder">No Image</div>
//                       )}
//                       <p>{kombination.Name}</p>
//                     </div>
//                   </Link>
//                 );
//               })}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default Combinations;



//BOTH

// src/components/Combinations.jsx

// import React, { useContext } from 'react';
// import { Link } from 'react-router-dom';
// import { CombinationContext } from '../contexts/CombinationContext';
// import '../styles/Category.css'; // Убедитесь, что стили доступны

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } = useContext(CombinationContext);

//   // Функция для формирования URL иконки
//   const getIconUrl = (icon) => {
//     if (!icon || !icon.filename_disk) return null;
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + '/assets/';
//     return `${baseUrl}${icon.filename_disk}`;
//   };

//   // Функция для определения группы по названию
//   const getGroup = (name) => {
//     if (!name) return null;
//     const upperName = name.toUpperCase();

//     if (upperName.startsWith('BE')) {
//       return 'Anhängerg';
//     } else if (upperName.startsWith('A')) {
//       return 'zweirad';
//     } else if (upperName.startsWith('B')) {
//       return 'Auto';
//     } else if (upperName.startsWith('C')) {
//       return 'LKW';
//     }
//     return null; // Если не соответствует ни одной группе
//   };

//   // Функция для группировки комбинаций
//   const groupCombinations = (kombinationen) => {
//     const groups = {
//       zweirad: [],
//       Auto: [],
//       LKW: [],
//       Anhängerg: []
//     };

//     kombinationen.forEach((kombination) => {
//       const group = getGroup(kombination.Name);
//       if (group && groups[group]) {
//         groups[group].push(kombination);
//       }
//     });

//     return groups;
//   };

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   // Группировка комбинаций
//   const groupedCombinations = groupCombinations(kombinationen);

//   // Порядок отображения групп
//   const groupOrder = ['zweirad', 'Auto', 'LKW', 'Anhängerg'];

//   return (
//     <div className="category app-wrapper">
//       <h2>Kombinationen</h2>


//       {/* Вариант 1: Без группировки */}
//       <section className="variant-section">
//         <h3>Variant 1: Alle Kombinationen ohne Gruppierung</h3>
//         <div className="cards2">
//           {kombinationen.map((kombination) => {
//             const iconUrl = getIconUrl(kombination.Icon);
//             return (
//               <Link 
//                 to={`/kombi/${kombination.id}`} 
//                 key={kombination.id} 
//                 className="card-wrapper2"
//                 style={{ textDecoration: 'none', color: 'inherit' }}
//               >
//                 <div className="card2">
//                   {/* Отображение иконки */}
//                   {iconUrl ? (
//                     <img
//                       src={iconUrl}
//                       alt={kombination.Name}
//                       className="category-icon"
//                       loading="lazy"
//                       onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }}
//                     />
//                   ) : (
//                     <div className="category-icon-placeholder">No Image</div>
//                   )}
//                   <p>{kombination.Name}</p>
//                 </div>
//               </Link>
//             );
//           })}
//         </div>
//       </section>



//       {/* Вариант 2: С группировкой */}
//       <section className="variant-section">
//         <h3>Variant 2: Kombinationen mit Gruppierung (HARDCODED)</h3>
//         {groupOrder.map((groupName) => {
//           const combinations = groupedCombinations[groupName];
//           if (!combinations || combinations.length === 0) return null;

//           // Определение заголовка группы
//           let groupTitle = '';
//           switch (groupName) {
//             case 'zweirad':
//               groupTitle = 'Zweirad';
//               break;
//             case 'Auto':
//               groupTitle = 'Auto';
//               break;
//             case 'LKW':
//               groupTitle = 'LKW';
//               break;
//             case 'Anhängerg':
//               groupTitle = 'Anhänger';
//               break;
//             default:
//               groupTitle = '';
//           }

//           return (
//             <div key={groupName} className="group-section">
//               <h3 className="section-title">{groupTitle}</h3>
//               <div className="cards2">
//                 {combinations.map((kombination) => {
//                   const iconUrl = getIconUrl(kombination.Icon);
//                   return (
//                     <Link 
//                       to={`/kombi/${kombination.id}`} 
//                       key={kombination.id} 
//                       className="card-wrapper2"
//                       style={{ textDecoration: 'none', color: 'inherit' }}
//                     >
//                       <div className="card2">
//                         {/* Отображение иконки */}
//                         {iconUrl ? (
//                           <img
//                             src={iconUrl}
//                             alt={kombination.Name}
//                             className="category-icon"
//                             loading="lazy"
//                             onError={(e) => { e.target.onerror = null; e.target.src = '/images/placeholder.png'; }}
//                           />
//                         ) : (
//                           <div className="category-icon-placeholder">No Image</div>
//                         )}
//                         <p>{kombination.Name}</p>
//                       </div>
//                     </Link>
//                   );
//                 })}
//               </div>
//             </div>
//           );
//         })}
//       </section>
//     </div>
//   );
// };

// export default Combinations;






// import React, { useContext } from "react";
// import { CombinationContext } from "../contexts/CombinationContext";
// import "../styles/Category.css";

// const CombinationIcons = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } = useContext(CombinationContext);

//   // Функция для формирования URL иконки
//   const getIconUrl = (iconId) => {
//     if (!iconId) {
//       console.log("Icon ID отсутствует:", iconId);
//       return null;
//     }
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + "/assets/";
//     console.log("Icon URL:", `${baseUrl}${iconId}`);
//     return `${baseUrl}${iconId}`;
//   };

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   console.log("kombinationen:", kombinationen);

//   return (
//     <div className="combination-icons">
//       <h2>Kombinationen Icons</h2>
//       {kombinationen.map((kombination) => {
//         console.log("Обрабатывается комбинация:", kombination);

//         if (!kombination.Klassen || kombination.Klassen.length === 0) {
//           console.log("Классы отсутствуют для комбинации:", kombination.Name);
//           return null; // Пропускаем комбинации без классов
//         }

//         return (
//           <div key={kombination.id} className="combination-item">
//             <h3>{kombination.Name}</h3>
//             <div className="icons-container">
//               {kombination.Klassen.map((klasse) => {
//                 console.log("Обрабатывается класс:", klasse);

//                 // Извлечение `Klassen_id` для получения данных о классе
//                 const classData = klasse.Klassen_id;
//                 if (!classData) {
//                   console.log("Klassen_id отсутствует для класса:", klasse);
//                   return null;
//                 }

//                 // Получение URL для иконки
//                 const iconUrl = getIconUrl(classData.Icon);

//                 return iconUrl ? (
//                   <img
//                     key={classData.id}
//                     src={iconUrl}
//                     alt={classData.Name}
//                     className="klasse-icon"
//                     loading="lazy"
//                     onError={(e) => {
//                       console.error("Ошибка загрузки иконки:", iconUrl);
//                       e.target.onerror = null;
//                       e.target.src = "/images/placeholder.png"; // Заменяем на плейсхолдер, если иконка не загрузилась
//                     }}
//                   />
//                 ) : (
//                   <div key={classData.id} className="klasse-icon-placeholder">
//                     No Icon
//                   </div>
//                 );
//               })}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );
// };

// export default CombinationIcons;



// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { CombinationContext } from "../contexts/CombinationContext";
// import "../styles/Category.css"; // Убедитесь, что стили доступны

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } =
//     useContext(CombinationContext);

//   // Функция для формирования URL иконки
//   const getIconUrl = (iconId) => {
//     if (!iconId) return null;
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + "/assets/";
//     return `${baseUrl}${iconId}`;
//   };

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   return (
//     <div className="category app-wrapper">
//       <h2>Kombinationen</h2>

//       {/* Вариант: Классы для каждой комбинации */}
//       <section className="variant-section">
//         <h3>Variant: Kombinationen mit Klassen</h3>
//         <div className="cards2">
//           {kombinationen.map((kombination) => {
//             return (
//               <div key={kombination.id} className="card-wrapper2">
//                 <div className="card2-combi">
//                   <h3>{kombination.Name}</h3>

//                   {/* Секция классов */}
//                   <div className="icons-container">
//                     {kombination.Klassen &&
//                       kombination.Klassen.map((klasse) => {
//                         const classData = klasse.Klassen_id;
//                         if (!classData) return null;

//                         const iconUrl = getIconUrl(classData.Icon);

//                         return iconUrl ? (
//                           <img
//                             key={classData.id}
//                             src={iconUrl}
//                             alt={classData.Name}
//                             className="klasse-icon-combi"
//                             loading="lazy"
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "/images/placeholder.png";
//                             }}
//                           />
//                         ) : (
//                           <div key={classData.id} className="klasse-icon-placeholder">
//                             No Icon
//                           </div>
//                         );
//                       })}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Combinations;

//Combinations.jsx

// import React, { useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { CombinationContext } from "../contexts/CombinationContext";
// import "../styles/Category.css";

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } =
//     useContext(CombinationContext);

//   const navigate = useNavigate(); // useNavigate


//   // Funktion zur Erstellung der URL für ein Icon
//   const getIconCombiUrl = (iconId) => {
//     if (!iconId) return null;
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + "/assets/";
//     return `${baseUrl}${iconId}`;
//   };

//   if (loadingKombinationen) {
//     return <p>Lade Kombinationen...</p>;
//   }

//   if (errorKombinationen) {
//     return <p>Fehler: {errorKombinationen}</p>;
//   }

//   return (
//     <div className="category app-wrapper">
      
//       <div className="container">
//           <button onClick={() => navigate(-1)} className="back-button">
//               <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
//           </button>

//           <h1 className="title">
//               Hier findest du alle <br /> <span>Kombis im Detail</span>
//           </h1>
//       </div>

//       {/* Вариант: Классы для каждой комбинации / Variante: Klassen für jede Kombination*/}
//       <section className="variant-section">
//         <div className="combis-container">
//         <div className="cards2">
//           {kombinationen.map((kombination) => {
//             return (
//               <Link
//                 to={`/kombi/${kombination.id}`}
//                 key={kombination.id}
//                 className="card-wrapper2"
//                 style={{ textDecoration: 'none', color: 'inherit' }}
//               >
//                 <div className="card2-combi">
//                   <h3>{kombination.Name}</h3>

//                   {/* Секция классов / Abschnitt für Klassen*/}
//                   <div className="icons-container">
//                     {kombination.Klassen &&
//                       kombination.Klassen.map((klasse) => {
//                         const classData = klasse.Klassen_id;
//                         if (!classData) return null;

//                         const iconUrl = getIconCombiUrl(classData.Icon);

//                         return iconUrl ? (
//                           <img
//                             key={classData.id}
//                             src={iconUrl}
//                             alt={classData.Name}
//                             className="klasse-icon-combi"
//                             loading="lazy"
//                             onError={(e) => {
//                               e.target.onerror = null;
//                               e.target.src = "/images/placeholder.png";
//                             }}
//                           />
//                         ) : (
//                           <div key={classData.id} className="klasse-icon-placeholder">
//                             No Icon
//                           </div>
//                         );
//                       })}
//                   </div>
//                 </div>
//               </Link>
//             );
//           })}
//         </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Combinations;



// import React, { useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { CombinationContext } from "../contexts/CombinationContext";
// import { ClassContext } from "../contexts/ClassContext"; // <-- подключение
// import "../styles/Category.css";

// const Combinations = () => {
//   const { kombinationen, loadingKombinationen, errorKombinationen } =
//     useContext(CombinationContext);

//   const { klassen: alleKlassen, loadingKlassen } = useContext(ClassContext); // <-- получаем классы

//   const navigate = useNavigate();

//   const getIconCombiUrl = (iconId) => {
//     if (!iconId) return null;
//     const baseUrl = process.env.REACT_APP_API_BASE_URL + "/assets/";
//     return `${baseUrl}${iconId}`;
//   };

//   const getKategorieNamen = (klassenArray) => {
//     const kategorien = klassenArray
//       .map((klasse) => {
//         const klassenId = klasse?.Klassen_id?.id;
//         const fullKlasse = alleKlassen.find((k) => k.id === klassenId);

//         return (
//           fullKlasse?.Kategorien
//             ?.map((kategorie) => kategorie?.Kategorien_id?.Name)
//             .filter(Boolean) || []
//         );
//       })
//       .flat();

//     return [...new Set(kategorien)];
//   };

//   if (loadingKombinationen || loadingKlassen) return <p>Lade Daten...</p>;
//   if (errorKombinationen) return <p>Fehler: {errorKombinationen}</p>;

//   return (
//     <div className="category app-wrapper">
//       <div className="container">
//         <button onClick={() => navigate(-1)} className="back-button">
//           <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)">
//             <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/>
//           </svg>
//         </button>
//         <h1 className="title">
//           Hier findest du alle <br /> <span>Kombis im Detail</span>
//         </h1>
//       </div>

//       <section className="variant-section">
//         <div className="combis-container">
//           <div className="cards2">
//             {kombinationen.map((kombination) => {
//               const kategorien = getKategorieNamen(kombination.Klassen);

//               return (
//                 <Link
//                   to={`/kombi/${kombination.id}`}
//                   key={kombination.id}
//                   className="card-wrapper2"
//                   style={{ textDecoration: 'none', color: 'inherit' }}
//                 >
//                   <div className="card2-combi">
//                     <h3>{kombination.Name}</h3>

//                     <p className="kategorie-namen">
//                       {kategorien.join(", ")}
//                     </p>

//                     <div className="icons-container">
//                       {kombination.Klassen &&
//                         kombination.Klassen.map((klasse) => {
//                           const classData = klasse.Klassen_id;
//                           const iconUrl = getIconCombiUrl(classData?.Icon);

//                           return iconUrl ? (
//                             <img
//                               key={classData.id}
//                               src={iconUrl}
//                               alt={classData.Name}
//                               className="klasse-icon-combi"
//                               loading="lazy"
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src = "/images/placeholder.png";
//                               }}
//                             />
//                           ) : (
//                             <div key={classData.id} className="klasse-icon-placeholder">
//                               No Icon
//                             </div>
//                           );
//                         })}
//                     </div>
//                   </div>
//                 </Link>
//               );
//             })}
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Combinations;


import React, { useContext, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { CombinationContext } from "../contexts/CombinationContext";
import { ClassContext } from "../contexts/ClassContext";
import "../styles/Category.css";

const Combinations = () => {
  const { kombinationen, loadingKombinationen, errorKombinationen } =
    useContext(CombinationContext);
  const { klassen: alleKlassen, loadingKlassen } = useContext(ClassContext);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();

  const getIconCombiUrl = (iconId) => {
    if (!iconId) return null;
    const baseUrl = process.env.REACT_APP_API_BASE_URL + "/assets/";
    return `${baseUrl}${iconId}`;
  };

  const getKategorieNamen = (klassenArray) => {
    const kategorien = klassenArray
      .map((klasse) => {
        const klassenId = klasse?.Klassen_id?.id;
        const fullKlasse = alleKlassen.find((k) => k.id === klassenId);
        return (
          fullKlasse?.Kategorien
            ?.map((k) => k?.Kategorien_id?.Name)
            .filter(Boolean) || []
        );
      })
      .flat();

    return [...new Set(kategorien)];
  };

  const kategorien = useMemo(() => {
    const result = [];
    for (const klasse of alleKlassen) {
      if (!klasse.Kategorien) continue;
      for (const kategorie of klasse.Kategorien) {
        const kat = kategorie.Kategorien_id;
        if (kat && kat.Hauptkategorie && !result.find((r) => r.id === kat.id)) {
          result.push(kat);
        }
      }
    }
    return result;
  }, [alleKlassen]);

  const getCategoryIcon = (icon) => {
    return icon ? `${process.env.REACT_APP_API_BASE_URL}/assets/${icon}` : null;
  };

  const filteredKombinationen = selectedCategory
    ? kombinationen.filter((kombination) =>
        kombination.Klassen.some((klasse) => {
          const full = alleKlassen.find((k) => k.id === klasse?.Klassen_id?.id);
          return full?.Kategorien?.some((k) => k.Kategorien_id?.id === selectedCategory.id);
        })
      )
    : [];

  if (loadingKombinationen || loadingKlassen) return <p>Lade Daten...</p>;
  if (errorKombinationen) return <p>Fehler: {errorKombinationen}</p>;

  return (
    <div className="category hauptkategorie-section app-wrapper">
      <div className="container2">
        <button onClick={() => navigate(-1)} className="back-button">
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--white)">
            <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/>
          </svg>
        </button>

        {!selectedCategory ? (
          <>
            <h1 className="title">
              Wähle eine <span>Kategorie</span>
            </h1>
            <div className="cards2">
              {kategorien.map((kat) => {
                const icon = getCategoryIcon(kat.Icon);
                return (
                    <div key={kat.id} className="card2" onClick={() => setSelectedCategory(kat)}>
                      <div className="card2-content">
                        <h3 dangerouslySetInnerHTML={{ __html: kat.Name }} />
                        <p>{kat.Beschreibung}</p>
                      </div>
                      <div className="category-icon">
                        {icon && <img src={icon} alt={kat.Name} />}
                      </div>
                    </div>
                );
              })}
            </div>
          </>
        ) : (
          <>
            <h1 className="title">
              Kombis für: <span>{selectedCategory.Name}</span>
            </h1>
            <button onClick={() => setSelectedCategory(null)} className="back-button">
              Zurück zur Kategorieauswahl
            </button>

            <section className="variant-section">
              <div className="combis-container">
                <div className="cards2">
                  {filteredKombinationen.map((kombination) => {
                    const kategorien = getKategorieNamen(kombination.Klassen);
                    return (
                      <Link
                        to={`/kombi/${kombination.id}`}
                        key={kombination.id}
                        className="card-wrapper2"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                      >
                        <div className="card2-combi">
                          <h3>{kombination.Name}</h3>
                          {/* <p className="kategorie-namen">{kategorien.join(", ")}</p> */}
                          <div className="icons-container">
                            {kombination.Klassen.map((klasse) => {
                              const classData = klasse.Klassen_id;
                              const iconUrl = getIconCombiUrl(classData?.Icon);
                              return iconUrl ? (
                                <img
                                  key={classData.id}
                                  src={iconUrl}
                                  alt={classData.Name}
                                  className="klasse-icon-combi"
                                  loading="lazy"
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "/images/placeholder.png";
                                  }}
                                />
                              ) : (
                                <div key={classData.id} className="klasse-icon-placeholder">No Icon</div>
                              );
                            })}
                          </div>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </section>
          </>
        )}
      </div>
    </div>
  );
};

export default Combinations;
